import { useMemo } from "react";
import { useSelector } from "react-redux";
import clsx from "clsx";

import GridCard from "components/GridCard";
import { BUSINESS_LISTS } from "constants/haulpay";
import { useColorScheme } from "hooks/useColorScheme";
import { useUserFeature } from "hooks/useUserFeature";
import MainLayout from "layouts/Main";
import { RootState } from "store";
import styles from "./style.module.scss";

export default function HaulPay() {
  const { currentIsDark } = useColorScheme();

  const {
    account: { type }
  } = useSelector((state: RootState) => state.authState);
  const {
    isFactoringApproved,
    isSubscribedUser,
    isInvitedCarrier,
    isConnectionsRole,
    isAssignedLoadsRole
  } = useUserFeature();

  const selectedType = () => {
    if (isFactoringApproved === "approved" || isSubscribedUser) {
      return type;
    } else if (isInvitedCarrier) {
      return "invited-carrier";
    } else {
      return type;
    }
  };

  const selectedList = useMemo(
    () => BUSINESS_LISTS.find((item) => item.businessType === selectedType()),
    [BUSINESS_LISTS, type]
  );

  const selectedData = useMemo(() => {
    let items = selectedList?.haulPayItems ?? [];
    if (!isConnectionsRole) {
      items = items.filter((pay) => pay.label !== "Connections");
    }
    if (!isAssignedLoadsRole) {
      items = items.filter((pay) => pay.label !== "Assigned");
    }
    return items;
  }, [selectedList, isConnectionsRole, isAssignedLoadsRole]);

  return selectedList ? (
    <MainLayout desktopTitle="Finance" subtitle={selectedList.subtitle} className="ml-4 mr-5">
      <div
        className={clsx(
          styles.haulpayGrid,
          !currentIsDark && "drop-shadow-[0_2px_4.5px_#9E9E9E33]"
        )}>
        {selectedData?.map((item) => <GridCard key={item.id} item={item} />)}
      </div>
    </MainLayout>
  ) : null;
}
